import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import LookupItemService from '../../../../Services/LookupItemService';
import ErrorMessage from '../../../ErrorMessage';

export default class LookupItemSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    showSelectFilterAt: 10,
    filterCleared: false,
    IsCheckBoxEnabled: false,
    changeOfEditedMultipItem: () => {},
    fieldName: 'defaultFieldname',
    onChange: () => {},
    lookupId: null,
    sort: false,
    onlyActive: false,
    editedItem: {},
    valueAsText: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    if (!this.props.lookupId) {
      this.setState({ selectValues: [] });
      return;
    }
    this.populateListData();
  }

  populateListData() {
    LookupItemService.GetLookupItemListByLookupId(this.props.lookupId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];

        if (this.props.sort) result.sort((a, b) => (a.text > b.text ? 1 : -1));

        result.forEach((lookupItem) => {
          const value = this.props.valueAsText ? lookupItem.text : lookupItem.value;
          if (this.props.onlyActive) {
            if (lookupItem.isActive) {
              optValues.push({
                label: lookupItem.text,
                value: value,
                disabled: false,
              });
            }
          } else {
            optValues.push({
              label: lookupItem.text,
              value: value,
              disabled: false,
            });
          }
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('LUS59');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        showSelectFilterAt={this.props.showSelectFilterAt}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
        IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
        changeOfEditedMultipItem={this.props.changeOfEditedMultipItem}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        editedItem={this.props.editedItem}
      />
    );
  }
}
